import { render, staticRenderFns } from "./BaseCheckIconText.vue?vue&type=template&id=71c18ed0&"
import script from "./BaseCheckIconText.vue?vue&type=script&lang=ts&"
export * from "./BaseCheckIconText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports